/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum AccreditationTypeEnum {
    A = 'A',
    Ap = 'AP',
    Infiintare = 'Infiintare',
    Lichidare = 'Lichidare'
}

export function AccreditationTypeEnumFromJSON(json: any): AccreditationTypeEnum {
    return AccreditationTypeEnumFromJSONTyped(json, false);
}

export function AccreditationTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccreditationTypeEnum {
    return json as AccreditationTypeEnum;
}

export function AccreditationTypeEnumToJSON(value?: AccreditationTypeEnum | null): any {
    return value as any;
}

